"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.datasheetPack = exports.datasheetMap = exports.datasheet = exports.filterDatasheetOp = void 0;
const compensator_1 = require("../../../../../../compensator");
const immer_1 = __importDefault(require("immer"));
const field_permission_map_1 = require("../../../../../../modules/database/store/reducers/resource/datasheet/field_permission_map");
const player_1 = require("../../../../../../modules/shared/player");
const redux_1 = require("redux");
const i18n_1 = require("../../../../../../exports/i18n");
//import { Events, Player } from '../../../../../shared/player';
const actions = __importStar(require("../../../../../shared/store/action_constants"));
const index_1 = require("../index");
const client_1 = require("./client");
const filterDatasheetOp = (state, action) => {
    return action.filter(action => {
        // OPs that filter comments
        if (action.p[2] === 'comments' && action.p[0] === 'recordMap' && ('li' in action || 'ld' in action)) {
            return false;
        }
        // if (action.n==OTActionName.ObjectDelete&&action.p.length==4) {//删除前先检查一下删除的对象对不对，用于解决网络不好关联增多的问题
        //   let elem = state.snapshot;
        //   if(!elem) return false;
        //   for (let j = 0; j < action.p.length; j++) {
        //     let p = action.p[j];
        //     if(!p) return false;
        //     elem = elem[p];
        //     if(!elem) return false;
        //   }
        //   // @ts-ignore
        //   if(((elem instanceof Array)&&!elem.includes(action.od[0]))||(!(elem instanceof Array)&&elem!=action.od)){
        //     console.log('filterDatasheetOp skip od ',action)
        //     return false;
        //   }
        // }
        // when state only contains part of the data, filter out actions that operate on non-existent records
        if (state.isPartOfData) {
            // if p[0] is recordMap, then p[1] is recordId
            // if action.p.length > 2, then action has setRecord feature
            return !(action.p[0] === 'recordMap' && action.p.length > 2 && !state.snapshot.recordMap[action.p[1]]);
        }
        return true;
    });
};
exports.filterDatasheetOp = filterDatasheetOp;
exports.datasheet = (0, immer_1.default)((state = null, action) => {
    if (action.type === actions.DATAPACK_LOADED) {
        // only include part of the data payload
        // can not cover the state that contains all the data
        if (state && action.payload.isPartOfData && !state.isPartOfData) {
            console.log('datasheet with part of data ignored');
            if (action.payload.forceFetch) { //不管咋地都刷新吧
                return action.payload;
            }
            return state;
        }
        // payload and state include part of the data, then need to merge them
        if (state && action.payload.isPartOfData && state.isPartOfData) {
            if (action.payload.forceFetch)
                return action.payload;
            if (action.payload.revision === state.revision) {
                state.snapshot.recordMap = Object.assign({}, action.payload.snapshot.recordMap, state.snapshot.recordMap);
            }
            else {
                player_1.Player.doTrigger(player_1.Events.app_error_logger, {
                    error: new Error((0, i18n_1.t)(i18n_1.Strings.error_the_version_is_inconsistent_while_preparing_to_merge)),
                    metaData: { name: state.name, id: state.id },
                });
            }
            return state;
        }
        return action.payload;
    }
    if (!state) {
        return null;
    }
    switch (action.type) {
        case actions.REFRESH_SNAPSHOT: {
            state.snapshot = Object.assign({}, state.snapshot);
            return state;
        }
        case actions.DATASHEET_JOT_ACTION: {
            (0, index_1.JOTApply)(state, action, exports.filterDatasheetOp);
            return state;
        }
        case actions.DATASHEET_UPDATE_REVISION: {
            state.revision = action.payload;
            return state;
        }
        case actions.CHANGE_VIEW: {
            state.activeView = action.payload;
            return state;
        }
        case actions.RECORD_NODE_DESC: {
            state.description = action.payload;
            return state;
        }
        case actions.SET_NODE_ICON: {
            state.icon = action.payload;
            return state;
        }
        case actions.UPDATE_DATASHEET: {
            state = Object.assign(Object.assign({}, state), action.payload);
            return state;
        }
        case actions.UPDATE_SNAPSHOT: {
            state.snapshot = action.payload;
            return state;
        }
        case actions.RECORD_NODE_SHARED: {
            state.nodeShared = action.payload;
            return state;
        }
        case actions.UPDATE_DATASHEET_NAME: {
            state.name = action.payload;
            return state;
        }
    }
    return state;
}, null);
const datasheetMap = (state = {}, action) => {
    if (!action.datasheetId) {
        return state;
    }
    if (action.type === actions.RESET_DATASHEET) {
        const newState = Object.assign({}, state);
        delete newState[action.datasheetId];
        return newState;
    }
    if (action.type === actions.ADD_DATASHEET) {
        const newState = Object.assign(Object.assign({}, state), { [action.datasheetId]: action.payload });
        return newState;
    }
    const result = (0, exports.datasheetPack)(state[action.datasheetId], action);
    if (result === state[action.datasheetId]) {
        return state;
    }
    return Object.assign(Object.assign({}, state), { [action.datasheetId]: result });
};
exports.datasheetMap = datasheetMap;
const computedInfo = (state = {}, action) => {
    if (action.type === actions.SET_DATASHEET_COMPUTED) {
        return action.payload;
    }
    if (action.type === actions.UPDATE_DATASHEET_COMPUTED) {
        compensator_1.compensator.clearAll();
        return Object.assign(Object.assign({}, state), action.payload);
    }
    return state;
};
const computedStatus = (state = {}, action) => {
    if (action.type === actions.SET_DATASHEET_COMPUTED_STATUS) {
        return Object.assign(Object.assign({}, state), action.payload);
    }
    return state;
};
exports.datasheetPack = (0, redux_1.combineReducers)({
    loading: (state = false, action) => {
        if (action.type === actions.DATAPACK_REQUEST) {
            return true;
        }
        if (action.type === actions.DATAPACK_LOADED || action.type === actions.DATASHEET_ERROR_CODE) {
            return false;
        }
        return state;
    },
    connected: (state = false, action) => {
        if (action.type === actions.DATASHEET_CONNECTED) {
            return true;
        }
        return state;
    },
    errorCode: (state = null, action) => {
        if (action.type === actions.DATASHEET_ERROR_CODE) {
            return action.payload;
        }
        if (action.type === actions.DATAPACK_REQUEST || action.type === actions.DATAPACK_LOADED) {
            return null;
        }
        return state;
    },
    syncing: (state = false, action) => {
        // for compatibility
        if (action.type === actions.SET_DATASHEET_SYNCING) {
            return action.payload;
        }
        return state;
    },
    datasheet: exports.datasheet,
    client: client_1.client,
    fieldPermissionMap: field_permission_map_1.fieldPermissionMap,
    computedInfo,
    computedStatus,
});
//# sourceMappingURL=datasheet.js.map